import { ToastContainer, ToastOptions } from 'react-toastify';
import styled from 'styled-components';

import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

export const CustomToastContainer = styled(ToastContainer)<ToastOptions>`
    min-width: 100%;
    width: auto;
    border-radius: 0;

    // react-toastify uses different breakpoints then Purpur
    @media only screen and (min-width: 481px) {
        min-width: 23.875rem;
        bottom: 0;
        right: auto;

        .Toastify__toast {
            border-radius: ${getPurpurSpacing('100')};
        }
    }

    ${purpurMedia('lg')`
        bottom: 0.875rem;
        left: 1.875rem;
    `};

    .Toastify__toast {
        padding: ${getPurpurSpacing('250')} 1.125rem;
        box-shadow: 0 0.125rem 0.5rem rgba(58, 58, 58, 0.12);
        background: ${getPurpurColor('gray600')};
        color: ${getPurpurColor('functionalWhite')};
        font-size: 0.875rem;
        font-weight: ${getPurpurTypography('weightBold')};
        font-family: 'TeliaSans', 'Helvetica Neue', 'Arial', sans-serif;
        width: auto;
        max-width: 35rem;

        &--error {
            background: ${getPurpurColor('red600')};
        }
    }

    .Toastify__toast-icon {
        display: none;
    }
`;

export const CustomToastContent = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    width: 100%;
`;

export const CustomToastText = styled.div`
    margin-left: 1.125rem;
    margin-right: ${getPurpurSpacing('200')};
`;

export const CustomToastButton = styled.div`
    margin-left: auto;
    line-height: 1;
    position: relative;
    font-weight: ${getPurpurTypography('weightNormal')};
    cursor: pointer;
    text-align: right;
    transition: color 0.15s ease-in-out;
    padding-left: ${getPurpurSpacing('200')};

    &:before {
        display: block;
        content: '';
        position: absolute;
        height: 2rem;
        width: 0.1rem;
        left: 0;
        transform: translateY(-50%);
        top: 50%;
        background: ${getPurpurColor('functionalWhite')};
        opacity: 0.1617;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.8);
    }
`;
